import LzString from 'lz-string'
import CryptoJS from 'crypto-js'

/**
 * @method lzString     用来压缩字符串
 * @param {string} str  要被压缩的字符串
 * @param {string} key  to是压缩  from是解压出来
 */
export const lzString = (str) => {
  return (key) => {
    if (key === 'to') {
      return LzString.compressToUTF16(str)
    } else if (key === 'from') {
      return LzString.decompressFromUTF16(str)
    }
  }
}

/**
 * @method encryptByDESModeEBC     DES ECB模式加密
 * @param {string} message         要被加密的字符串
 * @param {string} key             加密用的key
 */
export const encryptByDESModeEBC = (message, key) => {
  var keyHex = CryptoJS.enc.Utf8.parse(key)
  var encrypted = CryptoJS.DES.encrypt(message, keyHex, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  }).ciphertext
  var str = CryptoJS.enc.Base64.stringify(encrypted)
  return str
}

/**
 * @method encryptByDESModeEBC     DES ECB模式解密
 * @param {string} ciphertext      要被解密的字符串
 * @param {string} key             解密用的key
 */
export const decryptByDESModeEBC = (ciphertext, key) => {
  var keyHex = CryptoJS.enc.Utf8.parse(key)
  var decrypted = CryptoJS.DES.decrypt({ciphertext: CryptoJS.enc.Base64.parse(ciphertext)}, keyHex, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.NoPadding
  })
  return decrypted.toString(CryptoJS.enc.Utf8)
}



// WEBPACK FOOTER //
// ./src/assets/utils/lzString.js